import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { authGuard } from '../shared/guards/auth.guard';
import { eligableGuard } from 'src/shared/guards/eligable.guard';
import { UserRole } from 'src/core/helpers/user-roles';
import { LoginComponent } from './user/login/login.component';
import { SignupComponent } from './user/signup/signup.component';
import { AcceptInviteComponent } from './user/accept-invite/accept-invite.component';
import { OrganizationTitle } from 'src/core/helpers/organization-helper';
import { MaintenancePageComponent } from './maintenance-page/maintenance-page.component';
import { GeneralSettingsComponent } from './Settings/general-settings/general-settings.component';
import { LabelListComponent } from './label-list/label-list.component';
import { emailDomainGuard } from 'src/shared/guards/email-domain.guard';
const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [authGuard] },
  { path: 'labels/:boardId/invitation/:invitationId/user', component: SignupComponent },
  { path: 'labels/:boardId/accept-invite/:invitationId/:userId', component: AcceptInviteComponent },
  { path: 'labels', component: LabelListComponent,
    title: 'Labels - ' + (sessionStorage.getItem('organisation') == 'no' ? OrganizationTitle.MusicNest : OrganizationTitle.MPO)
   },
  { path: 'login', component: LoginComponent, title: window.location.href.includes('no') ? OrganizationTitle.MusicNest : OrganizationTitle.MPO },
  {
    path: 'settings/:id',
    component: GeneralSettingsComponent,
    canActivate: [authGuard, eligableGuard],
    data: {
      roles: [UserRole.Superadmin, UserRole.LabelAdmin, UserRole.LabelUser, UserRole.LabelAgent]
    },
    title: 'Settings - ' + (sessionStorage.getItem('organisation') == 'no' ? OrganizationTitle.MusicNest : OrganizationTitle.MPO)
  },
  {
    path: 'maintenance',
    component: MaintenancePageComponent
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
    canActivate: [authGuard],
  },
  {
    path: 'disputes',
    loadChildren: () =>
      import('./disputed-items/disputed-items.module').then((m) => m.DisputedItemsModule),
    canActivate: [authGuard],
    data: { roles: [UserRole.Superadmin, UserRole.LabelAdmin] },
  },
  {
    path: 'invite-user/:boardId',
    loadChildren: () => import('./user/invite-user/invite-user.module').then(m => m.InviteUserModule),
    canActivate: [authGuard, eligableGuard],
    data: { roles: [UserRole.Superadmin, UserRole.LabelAdmin] },
  },
  {
    path: 'profile-settings',
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
    canActivate: [authGuard],
  },
  {
    path: 'old-finance',
    loadChildren: () =>
      import('./finance/finance.module').then((m) => m.FinanceModule),
    canActivate: [authGuard],
  },
  {
    path: 'old-distributions',
    loadChildren: () =>
      import('./distributions/distributions.module').then((m) => m.DistributionModule),
    canActivate: [authGuard],
  },
  {
    path: 'search',
    loadChildren: () =>
      import('./search-assign/search-assign.module').then((m) => m.SearchAssignModule),
    canActivate: [authGuard, eligableGuard],
    data: { roles: [UserRole.Superadmin, UserRole.LabelAdmin, UserRole.LabelUser, UserRole.LabelAgent] },
  },
  {
    path: 'admin/redis-sync',
    loadChildren: () =>
      import('./admin-tools/redis-sync-page/redis-sync-page.module').then((m) => m.RedisSyncPageModule),
    canActivate: [authGuard, eligableGuard, emailDomainGuard],
    data: { roles: [UserRole.Superadmin] },
  },
  {
    path: 'datatool',
    loadChildren: () => import('./admin-tools/data-tool/data-tool.module').then(m => m.DataToolModule),
    canActivate: [authGuard, eligableGuard],
    data: { roles: [UserRole.Superadmin] },
  },
  {
    path: 'audit',
    loadChildren: () => import('./admin-tools/audit-dashboard/audit-dashboard.module').then(m => m.AuditDashboardModule),
    canActivate: [authGuard, eligableGuard, emailDomainGuard],
    data: { roles: [UserRole.Superadmin] },
  },
  {
    path: 'distributions',
    loadChildren: () =>
      import('./new-finance/new-distributions/new-distributions.module').then(
        (m) => m.NewDistributionsModule
      ),
    canActivate: [authGuard, eligableGuard],
    data: { roles: [UserRole.Superadmin] },
  },
  {
    path: 'finance',
    loadChildren: () =>
      import('./new-finance/earnings/earnings-module').then(
        (m) => m.EarningsModule
      ),
    canActivate: [authGuard, eligableGuard],
    data: { roles: [UserRole.Superadmin, UserRole.LabelAdmin, UserRole.LabelUser, UserRole.LabelAgent] },
  },
  // otherwise redirect to home
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
